import { render, staticRenderFns } from "./preamble-component.vue?vue&type=template&id=fcdd0f38&scoped=true&"
import script from "./preamble-component.vue?vue&type=script&lang=ts&"
export * from "./preamble-component.vue?vue&type=script&lang=ts&"
import style0 from "./preamble-component.vue?vue&type=style&index=0&id=fcdd0f38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdd0f38",
  null
  
)

export default component.exports